module.exports = __webpack_public_path__ + "img/c06_unittechroyalguardchampion_Normal_ua.f5bd126b.webp";